import React from "react";
import { SITE_WATERMARK } from "@/lib/constants";

/**
 * Branded image wrapper that overlays the site watermark (bottom-right).
 * Drop-in replacement for <img>; supports same className/style and a few helpers.
 *
 * Usage:
 *   <BrandedImage src={url} alt="..." className="absolute inset-0 w-full h-full object-cover" />
 *
 * Optional props:
 *   - watermarkPosition: "br" (default) | "bl" | "tr" | "tl"
 *   - hideWatermark: boolean (default false) — set true ONLY for logos/avatars
 *   - rounded: pass-through for parent rounding
 */
export const BrandedImage = ({
  src,
  alt = "",
  className = "",
  style,
  watermarkPosition = "br",
  hideWatermark = false,
  loading = "lazy",
  ...rest
}) => {
  const posClass =
    watermarkPosition === "bl"
      ? "bottom-2 left-2"
      : watermarkPosition === "tr"
      ? "top-2 right-2"
      : watermarkPosition === "tl"
      ? "top-2 left-2"
      : "bottom-2 right-2";

  return (
    <div className={`relative ${className}`} style={style} data-testid="branded-image">
      <img
        src={src}
        alt={alt}
        loading={loading}
        className="absolute inset-0 w-full h-full object-cover"
        {...rest}
      />
      {!hideWatermark && (
        <span
          aria-hidden
          className={`absolute ${posClass} pointer-events-none select-none text-[10px] md:text-[11px] font-medium tracking-wider px-2 py-0.5 rounded-sm bg-black/45 backdrop-blur-[2px] text-white/85 z-10`}
          style={{ textShadow: "0 1px 2px rgba(0,0,0,0.6)" }}
        >
          {SITE_WATERMARK}
        </span>
      )}
    </div>
  );
};

export default BrandedImage;
